// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file AirSpaceBoundaryDTO.proto (package AirSpaceBoundaryDTO, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AirSpaceBoundaryVertex } from "./AirSpaceBoundaryVertex_pb";
import { file_AirSpaceBoundaryVertex } from "./AirSpaceBoundaryVertex_pb";
import type { AirSpaceBoundaryVertexLine } from "./AirSpaceBoundaryVertexLine_pb";
import { file_AirSpaceBoundaryVertexLine } from "./AirSpaceBoundaryVertexLine_pb";
import type { Navaid } from "./Navaid_pb";
import { file_Navaid } from "./Navaid_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file AirSpaceBoundaryDTO.proto.
 */
export const file_AirSpaceBoundaryDTO: GenFile = /*@__PURE__*/
  fileDesc("ChlBaXJTcGFjZUJvdW5kYXJ5RFRPLnByb3RvEhNBaXJTcGFjZUJvdW5kYXJ5RFRPIrQEChNBaXJTcGFjZUJvdW5kYXJ5RFRPEjgKEmFpcnNwYWNlYm91bmRhcnlpZBgBIAEoCzIcLmdvb2dsZS5wcm90b2J1Zi5TdHJpbmdWYWx1ZRItCghjb25maWdJZBgCIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEicKAmlkGAMgASgLMhsuZ29vZ2xlLnByb3RvYnVmLkludDMyVmFsdWUSLQoJbWFwc3RhdHVzGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLkJvb2xWYWx1ZRIqCgRuYW1lGAUgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlEi4KCXByb2plY3RJZBgGIAEoCzIbLmdvb2dsZS5wcm90b2J1Zi5JbnQzMlZhbHVlEi4KCHVuaXF1ZWlkGAcgASgLMhwuZ29vZ2xlLnByb3RvYnVmLlN0cmluZ1ZhbHVlElgKIGFpclNwYWNlQm91bmRhcnlDb29yZGluYXRlUG9pbnRzGAggAygLMi4uQWlyU3BhY2VCb3VuZGFyeVZlcnRleC5BaXJTcGFjZUJvdW5kYXJ5VmVydGV4ElUKFWFpclNwYWNlQm91bmRhcnlMaW5lcxgJIAMoCzI2LkFpclNwYWNlQm91bmRhcnlWZXJ0ZXhMaW5lLkFpclNwYWNlQm91bmRhcnlWZXJ0ZXhMaW5lEh8KB25hdmFpZHMYCiADKAsyDi5OYXZhaWQuTmF2YWlkQkkKLWNvbS5nbXYuZGVtZXRlci5uYXZhaWRzLm1vZGVsLnByb3RvLmdlbmVyYXRlZEIYQWlyU3BhY2VCb3VuZGFyeURUT1Byb3RvYgZwcm90bzM", [file_AirSpaceBoundaryVertex, file_AirSpaceBoundaryVertexLine, file_Navaid, file_google_protobuf_wrappers]);

/**
 * @generated from message AirSpaceBoundaryDTO.AirSpaceBoundaryDTO
 */
export type AirSpaceBoundaryDTO = Message<"AirSpaceBoundaryDTO.AirSpaceBoundaryDTO"> & {
  /**
   * @generated from field: google.protobuf.StringValue airspaceboundaryid = 1;
   */
  airspaceboundaryid?: string;

  /**
   * @generated from field: google.protobuf.Int32Value configId = 2;
   */
  configId?: number;

  /**
   * @generated from field: google.protobuf.Int32Value id = 3;
   */
  id?: number;

  /**
   * @generated from field: google.protobuf.BoolValue mapstatus = 4;
   */
  mapstatus?: boolean;

  /**
   * @generated from field: google.protobuf.StringValue name = 5;
   */
  name?: string;

  /**
   * @generated from field: google.protobuf.Int32Value projectId = 6;
   */
  projectId?: number;

  /**
   * @generated from field: google.protobuf.StringValue uniqueid = 7;
   */
  uniqueid?: string;

  /**
   * @generated from field: repeated AirSpaceBoundaryVertex.AirSpaceBoundaryVertex airSpaceBoundaryCoordinatePoints = 8;
   */
  airSpaceBoundaryCoordinatePoints: AirSpaceBoundaryVertex[];

  /**
   * @generated from field: repeated AirSpaceBoundaryVertexLine.AirSpaceBoundaryVertexLine airSpaceBoundaryLines = 9;
   */
  airSpaceBoundaryLines: AirSpaceBoundaryVertexLine[];

  /**
   * @generated from field: repeated Navaid.Navaid navaids = 10;
   */
  navaids: Navaid[];
};

/**
 * Describes the message AirSpaceBoundaryDTO.AirSpaceBoundaryDTO.
 * Use `create(AirSpaceBoundaryDTOSchema)` to create a new message.
 */
export const AirSpaceBoundaryDTOSchema: GenMessage<AirSpaceBoundaryDTO> = /*@__PURE__*/
  messageDesc(file_AirSpaceBoundaryDTO, 0);

